import React from "react";

const CallArea = () => {
  return (
    <section className="gauto-call-area">
      <div className="container">
        <div className="row">
          <div className="col-md-12">

            <div className="call-box">
              <div className="call-box-inner">

                <h2>
                  Trusted by <span>5150+</span> Customers Across the City
                </h2>

                <p>
                  Shambhu Cabs offers reliable, safe, and affordable taxi services
                  for city rides, airport transfers, outstation trips, and more.
                  We ensure punctual drivers, clean cars, and a comfortable
                  travel experience every time you ride with us.
                </p>

                <div className="call-number">
                  <div className="call-icon">
                    <i className="fa fa-phone"></i>
                  </div>

                  <div className="call-text">
                    <p>Need any help?</p>
                    <h4>
                      <a href="tel:9819399797">(+91) 9819399797</a>
                    </h4>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default CallArea;
